import { render, staticRenderFns } from "./DeclaracaoNormal.vue?vue&type=template&id=ccf74100&scoped=true&"
import script from "./DeclaracaoNormal.vue?vue&type=script&lang=js&"
export * from "./DeclaracaoNormal.vue?vue&type=script&lang=js&"
import style0 from "./DeclaracaoNormal.vue?vue&type=style&index=0&id=ccf74100&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccf74100",
  null
  
)

export default component.exports